var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.000000, 4.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2,
    y: 8,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(10.000000, 6.000000) scale(1, -1) translate(-10.000000, -6.000000) ",
    x: 0,
    y: 4,
    width: 20,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,3 C13,1.34314575 11.6568542,0 10,0 C8.34314575,0 7,1.34314575 7,3",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.03796387,
    y1: 11.8165283,
    x2: 6.03796387,
    y2: 20.0388184,
    id: "Path-30",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 11.8165283,
    x2: 10,
    y2: 20.0388184,
    id: "Path-30-Copy",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 11.8165283,
    x2: 14,
    y2: 20.0388184,
    id: "Path-30-Copy-2",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.59118a53ef7c98cc5deac2792c1c2e16.svg";
export { ForwardRef as ReactComponent };